// Test IDs for the two public legal pages (/privacy and /terms). Keys camelCase,
// values kebab-case — see auth.js.
//
// One page component renders both documents, so the ids are parameterised by the
// document rather than duplicated: `LEGAL.page('privacy')`. A section's id carries
// its own key, which is what lets a test assert that a specific disclosure is on
// the page rather than that the page merely rendered something.

export const LEGAL = {
  page: (doc) => `legal-${doc}`,
  title: (doc) => `legal-${doc}-title`,
  updated: 'legal-updated',
  section: (key) => `legal-section-${key}`,
  home: 'legal-home',
};
